import { IS_VERCEL_PROD } from '@monoimin/constants';

export function InvalidLinkMessage() {
  if (IS_VERCEL_PROD) {
    return null;
  }
  return (
    <span className='text-red-500'>invalid link url provided as href</span>
  );
}
